import { useEffect, useRef } from "react";
import { audioEngine } from "../../audio/audioEngine";
import type { AttackSoundStyle } from "../../audio/audioEngine";
import type {
  BattleImpact,
  BattlePhase
} from "../domain/battleMachine";

interface BattleAudioOptions {
  feedback: "idle" | "correct" | "incorrect";
  impact: BattleImpact;
  phase: BattlePhase;
  opponentAttackStyle: AttackSoundStyle;
}

export function useBattleAudio({
  feedback,
  impact,
  phase,
  opponentAttackStyle
}: BattleAudioOptions) {
  const previousImpactId = useRef(impact.eventId);
  const previousPhase = useRef<BattlePhase>(phase);

  useEffect(() => {
    if (
      impact.eventId > 0
      && impact.eventId !== previousImpactId.current
      && feedback !== "idle"
    ) {
      const attackStyle = impact.target === "player"
        ? opponentAttackStyle
        : impact.kind === "special"
          ? "magic"
          : "melee";
      audioEngine.playImpact(impact, feedback, attackStyle);
    }
    previousImpactId.current = impact.eventId;
  }, [feedback, impact, opponentAttackStyle]);

  useEffect(() => {
    if (previousPhase.current === "playing" && phase !== "playing") {
      const resultTimer = window.setTimeout(() => audioEngine.playResult(phase), 430);
      previousPhase.current = phase;
      return () => window.clearTimeout(resultTimer);
    }

    previousPhase.current = phase;
  }, [phase]);
}
